import React, { useState, useEffect } from 'react'
import styles from "./colorPalette.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, Grid, Container, GridRow, GridColumn, Input } from "semantic-ui-react";
import { updateColor } from "actions/color";
import cx from "classnames";
import { defaultColorPalette } from 'constants/initialColor';
import _ from "lodash";
import { toast } from "react-toastify";
import { useParams} from "react-router-dom";

export default function ColorCustomization() {

  const brand = useSelector((state) => _.get(state.accounts.account, "brandTheme"))
  const account = useSelector((state) => state.accounts.account);
  const updatingColor = useSelector(
    (state) => state.accounts.updatingColor
  );
  const [initialColorPalette, setInitialColorPalette] = useState()
  const [initialRender, setInitialRender] = useState(true);
  const [initialBrandTheme, setInitialBrandTheme] = useState();
  const [disableSave, setDisableSave] = useState(true);
  const params = useParams();
  useEffect(() => {
    if (brand == null) {
      setInitialColorPalette(defaultColorPalette);
      setInitialBrandTheme(defaultColorPalette)

    }
    else {
      setInitialColorPalette(brand);
      setInitialBrandTheme(brand)
    }
  }, [brand]);

  const dispatch = useDispatch();


  useEffect(() => {
    if (!initialRender && !updatingColor.updating) {
      if (updatingColor.success) {
        toast.success(`${account.name} color updated`);
      } else {
        toast.error(`failed to update ${account.name} color`);
      }
    }
  }, [updatingColor]);

  setTimeout(() => {
    setInitialRender(false);
  }, 3000);

  const handleColorClick = () => {

    dispatch(
      updateColor(
        {
          initialColorPalette, id: account.id
        }
      )
    )
    setDisableSave(true);
  }

  const handleReset = () => {

    setInitialColorPalette(initialBrandTheme)
    setDisableSave(true)

  }
  const handleColorChange = (key, subKey, value) => {
      if (_.size(key) === 0) {

        setInitialColorPalette({
          ...initialColorPalette,
          [subKey]: value
        })
      }
      else{
      setInitialColorPalette({
        ...initialColorPalette,
        [key]: {
          ...initialColorPalette[key],
          [subKey]: value
        }
      })
    }
    setDisableSave(false);
    
  }
  if (params.product === "cleverstory") {
    return null;
  }
  return (

    <div>

      <Container className={styles.container}>

        <Form>
          <Grid>
            <Grid.Row>
              <Grid.Column className={cx(styles.primarytext)}>Brand theme color</Grid.Column>
            </Grid.Row>
          </Grid>
          <Grid>
            <Grid.Row>
              <Grid.Column className={cx(styles.primary)}>Primary color</Grid.Column>
            </Grid.Row>
          </Grid>
          <Form.Field className={cx(styles.field)}>
            <Input
              className={cx(styles.inputField)}
              onChange={(e) =>
                handleColorChange("", "primaryColor", e.target.value)
              }
              value={_.get(initialColorPalette, "primaryColor")}
              
            />

          </Form.Field>
          <Grid columns='equal' className={cx(styles.colorName)}>
            <Grid.Row className={cx(styles.colorPaletteName)}>
              <Grid.Column className={cx(styles.primaryColor)}>Primary color palette</Grid.Column>
              <Grid.Column className={cx(styles.secondaryColor)}>Secondary color palette</Grid.Column>
              <Grid.Column className={cx(styles.sliderColor)}>Slider color palette</Grid.Column>
            </Grid.Row>
          </Grid>

          <Grid container columns={4} className={cx(styles.gridcols)}>
            <Grid.Column className={cx(styles.colorfieldName)}>
              <Form.Field>Background color</Form.Field>
              <Form.Field>Text color</Form.Field>
              <Form.Field>SubText color</Form.Field>
              <Form.Field>Separator color</Form.Field>
              <Form.Field>Disabled color</Form.Field>
            </Grid.Column>
          <GridColumn className={cx(styles.gridOne)}>
              <Form.Field className={cx(styles.fieldName)}>
                <Input
                  className={cx(styles.inputBox)}
                  onChange={(e) =>
                    handleColorChange("primaryPalette", "backgroundColor", e.target.value)

                  }
                  value={_.get(initialColorPalette, "primaryPalette.backgroundColor")}
                  />

              </Form.Field>
              <Form.Field className={cx(styles.fieldName)}>

                <Input
                  className={cx(styles.inputBox)}
                  onChange={(e) =>
                    handleColorChange("primaryPalette", "textColor", e.target.value)
                  }
                  value={_.get(initialColorPalette, "primaryPalette.textColor")}
                  
                />
              </Form.Field>
              <Form.Field className={cx(styles.fieldName)}>
                <Input
                  className={cx(styles.inputBox)}
                  onChange={(e) =>
                    handleColorChange("primaryPalette", "subTextColor", e.target.value)
                  }
                  value={_.get(initialColorPalette, "primaryPalette.subTextColor")}
                  
                />
              </Form.Field>
              <Form.Field className={cx(styles.fieldName)}>
                <Input
                  className={cx(styles.inputBox)}
                  onChange={(e) =>
                    handleColorChange("primaryPalette", "separatorColor", e.target.value)
                  }
                  value={_.get(initialColorPalette, "primaryPalette.separatorColor")}
                  
                />
              </Form.Field>
              <Form.Field className={cx(styles.fieldName)}>

                <Input
                  className={cx(styles.inputBox)}
                  onChange={(e) =>
                    handleColorChange("primaryPalette", "disabledColor", e.target.value)
                  }
                  value={_.get(initialColorPalette, "primaryPalette.disabledColor")}
                  
                />
              </Form.Field>
            </GridColumn>
            <GridColumn className={cx(styles.gridTwo)}>
              <Form.Field className={cx(styles.fieldName)}>
                <Input
                  className={cx(styles.inputBox)}
                  onChange={(e) =>
                    handleColorChange("secondaryPalette", "backgroundColor", e.target.value)
                  }
                  value={_.get(initialColorPalette, "secondaryPalette.backgroundColor")}
                  
                />
              </Form.Field>




              <Form.Field className={cx(styles.fieldName)}>
                <Input
                  className={cx(styles.inputBox)}
                  onChange={(e) =>
                    handleColorChange("secondaryPalette", "textColor", e.target.value)
                  }
                  value={_.get(initialColorPalette, "secondaryPalette.textColor")}
                  
                />
              </Form.Field>


              <Form.Field className={cx(styles.fieldName)}>
                <Input
                  className={cx(styles.inputBox)}
                  onChange={(e) =>
                    handleColorChange("secondaryPalette", "subTextColor", e.target.value)
                  }
                  value={_.get(initialColorPalette, "secondaryPalette.subTextColor")}
                  
                />
              </Form.Field>


              <Form.Field className={cx(styles.fieldName)}>
                <Input
                  className={cx(styles.inputBox)}
                  onChange={(e) =>
                    handleColorChange("secondaryPalette", "separatorColor", e.target.value)
                  }
                  value={_.get(initialColorPalette, "secondaryPalette.separatorColor")}
                  
                />
              </Form.Field>


              <Form.Field className={cx(styles.fieldName)}>
                <Input
                  className={cx(styles.inputBox)}
                  onChange={(e) =>
                    handleColorChange("secondaryPalette", "disabledColor", e.target.value)
                  }
                  value={_.get(initialColorPalette, "secondaryPalette.disabledColor")}
                  
                />
              </Form.Field>
            </GridColumn>

            <GridColumn className={cx(styles.gridThree)}>
              <Form.Field className={cx(styles.fieldName)}>
                <Input
                  className={cx(styles.inputBox)}
                  onChange={(e) =>
                    handleColorChange("sliderPalette", "backgroundColor", e.target.value)
                  }
                  value={_.get(initialColorPalette, "sliderPalette.backgroundColor")}
                  
                />
              </Form.Field>


              <Form.Field className={cx(styles.fieldName)}>
                <Input
                  className={cx(styles.inputBox)}
                  onChange={(e) =>
                    handleColorChange("sliderPalette", "textColor", e.target.value)
                  }
                  value={_.get(initialColorPalette, "sliderPalette.textColor")}
                  
                />
              </Form.Field>


              <Form.Field className={cx(styles.fieldName)}>
                <Input
                  className={cx(styles.inputBox)}
                  onChange={(e) =>
                    handleColorChange("sliderPalette", "subTextColor", e.target.value)
                  }
                  value={_.get(initialColorPalette, "sliderPalette.subTextColor")}
                  
                />
              </Form.Field>

              <Form.Field className={cx(styles.fieldName)}>
                <Input
                  className={cx(styles.inputBox)}
                  onChange={(e) =>
                    handleColorChange("sliderPalette", "separatorColor", e.target.value)
                  }
                  value={_.get(initialColorPalette, "sliderPalette.separatorColor")}
                  
                />
              </Form.Field>



              <Form.Field className={cx(styles.fieldName)}>
                <Input
                  className={cx(styles.inputBox)}
                  onChange={(e) =>
                    handleColorChange("sliderPalette", "disabledColor", e.target.value)
                  }
                  value={_.get(initialColorPalette, "sliderPalette.disabledColor")}
                 
                />

              </Form.Field>

            </GridColumn>

          </Grid>

          <Grid className={cx(styles.saveReset)}>
            <Button onClick={() => handleColorClick()} className={cx(styles.saving)} disabled ={disableSave}>Save Changes</Button>
            <Button onClick={() => handleReset()} className={cx(styles.resetButton)}>Reset</Button>
          </Grid>
        </Form>
      </Container>
    </div>
  )
}